import { Form, Modal } from "antd";
import React from "react";
import { CreateCarbonWasteRecycleDto } from "../../../../api";
import { CarbonWasteRecycleColumns } from "../form/columns";

interface CarbonWasteRecycleFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateCarbonWasteRecycle: (values: CreateCarbonWasteRecycleDto) => void;
}

export const CarbonWasteRecycleForm: React.FC<CarbonWasteRecycleFormProps> = ({ visible, setVisible, onCreateCarbonWasteRecycle }) => {
  const [form] = Form.useForm<CreateCarbonWasteRecycleDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateCarbonWasteRecycle}>
        {CarbonWasteRecycleColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
